import React from 'react';
import { Checkbox as MuiCheckbox } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

import styles from './checkBox.style';

const CheckBox = ({ value, onChange, disabled = false, sx, ...rest }) => {
  const icon = (
    <CheckBoxOutlineBlankIcon
      data-testid="CheckBoxOutlineBlankIcon"
      sx={styles.icon}
    />
  );
  const checkedIcon = (
    <CheckBoxIcon data-testid="CheckBoxIcon" sx={styles.icon} />
  );

  const _handleChange = (e) => onChange(e.target.checked);

  return (
    <MuiCheckbox
      icon={icon}
      checkedIcon={checkedIcon}
      onChange={_handleChange}
      checked={!!value}
      disabled={disabled}
      sx={[styles.checkbox, sx]}
      data-testid={`input-${rest?.name || 'check-box'}`}
      {...rest}
    />
  );
};

export default CheckBox;
